module.exports = __webpack_public_path__ + "static/media/12.dccd3198.png";